import React, { ReactNode } from "react";

interface BoxProps {
  title?: string;
  children: ReactNode;
  className?: string;
  padded?: boolean;
}

const Box: React.FC<BoxProps> = ({
  title,
  children,
  className = "",
  padded = true,
}) => {
  const commonClasses = `border bg-slate-100 border-slate-300 ${
    padded ? "p-4" : ""
  }`;

  return (
    <div className={className}>
      {title?.length && (
        <h1 className={`rounded-t font-bold border-b-0 ${commonClasses}`}>
          {title}
        </h1>
      )}
      <div className={`rounded-b ${commonClasses}`}>{children}</div>
    </div>
  );
};
export default Box;
